import React from "react";
import "./PopupTesti.css";
import Star from "./assets/star.svg";
import StarBlank from "./assets/star-blank.svg";
import axios from "axios";
import { joinWebinar } from "../../services/joinWebinar";

export default function PopupTesti(props) {
  const { data, close, send, changeReason, changeRate, loading, email } = props;

  return (
    <div id="reason-box">
      <section>
        <div className="head">
          <img onClick={close} src="/assets/images/e_close.svg" alt="close" />
        </div>
        <div className="schedules">
          <p>Webinar</p>
          <h1>{data?.name}</h1>
        </div>
        <h4>Berikan penilaian untuk webinar</h4>
        <div className="stared">
          {[1, 2, 3, 4, 5].map((d, i) => (
            <img
              onClick={() => {
                const url = process.env.REACT_APP_FETCH_URL + "/set-feedback-schedule";
                axios.post(url, {
                  ...data,
                  score: d,
                });

                if (email && data?.scheduleId) {
                  joinWebinar(email, data?.scheduleId); 
                }
                
                changeRate(d);
              }}
              src={data?.score >= d ? Star : StarBlank}
              key={i}
              alt="rating"
            />
          ))}
        </div>
        <h4 className="isi">Tuliskan ulasan kamu ikut webinar</h4>
        <textarea
          onChange={(e) => {
            changeReason(e.target.value);
          }}
          value={data?.reason}
          placeholder="Tulis alasannya di sini"
        />
        <div className="ctas">
          <button
            disabled={
              loading ||
              data?.reason === "" ||
              !data?.reason ||
              !data?.memberId ||
              data?.memberId === ""
            }
            style={{
              background:
                loading ||
                data?.reason === "" ||
                !data?.reason ||
                !data?.memberId ||
                data?.memberId === ""
                  ? "#999"
                  : "#7d61d6",
            }}
            onClick={send}
            className="send"
          >
            <p>{loading ? "Loading..." : "Kirim Ulasan"}</p>
          </button>
        </div>
      </section>
    </div>
  );
}
